"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const CheckboxCheckmark = require("../../../volkswagen-onehub/icons-core/dist");

const text_1 = require("../text");
const theme_provider_1 = require("../theme-provider");
var CheckboxAppearance;
(function (CheckboxAppearance) {
    CheckboxAppearance[CheckboxAppearance["Error"] = 0] = "Error";
})(CheckboxAppearance = exports.CheckboxAppearance || (exports.CheckboxAppearance = {}));
const noop = () => undefined;
const StyledLabel = theme_provider_1.styled.label.withConfig({ displayName: "StyledLabel", componentId: "sc-it8dh0" }) `
	position: relative;
	color: ${props => props.theme.interaction.recipe450.default};
	cursor: pointer;
`;
const StyledCheckboxWrapper = theme_provider_1.styled.span.withConfig({ displayName: "StyledCheckboxWrapper", componentId: "sc-410vg" }) `
	position: relative;
	display: flex;
	align-items: center;
`;
const StyledCheckboxCheckmark = theme_provider_1.styled(CheckboxCheckmark.CheckboxCheckmark).withConfig({ displayName: "StyledCheckboxCheckmark", componentId: "sc-o02w1h" }) `
	position: absolute;
	opacity: 0;
	display: flex;
	align-items: center;
`;
const StyledFocusWrapper = theme_provider_1.styled.span.withConfig({ displayName: "StyledFocusWrapper", componentId: "sc-yyclti" }) `
	position: relative;
	display: grid;
	grid-column-gap: ${props => props.theme.size.static200};
	grid-template-columns: max-content auto;
	align-items: center;

	&:hover {
		${StyledCheckboxWrapper} {
			&::before {
				content: '';
				position: absolute;
				top: -${props => props.theme.size.static150};
				left: -${props => props.theme.size.static150};
				height: ${props => `calc(100% + ${props.theme.size.static250})`};
				width: ${props => `calc(100% + ${props.theme.size.static250})`};
				background-color: ${props => props.theme.hoverIndicatorColor.outlinedElement.default};
				transition: ${props => props.theme.animation.duration.duration400};
				border-radius: 50%;
			}
		}
	}
`;
const StyledErrorText = theme_provider_1.styled.span.withConfig({ displayName: "StyledErrorText", componentId: "sc-1b1p7hb" }) `
	display: block;
	color: ${props => props.theme.interaction.recipe360.default};
	font-size: ${props => props.theme.textAppearances.copy0100.fontSize};
`;
const StyledInput = theme_provider_1.styled.input.withConfig({ displayName: "StyledInput", componentId: "sc-17lkls2" }) `
	position: absolute;
	opacity: 0;
	outline: 0;
	user-select: none;
	pointer-events: none;

	:checked {
		+ ${StyledFocusWrapper} {
			color: ${props => props.theme.interaction.recipe450.checked};

			${StyledCheckboxWrapper} {
				${StyledCheckboxCheckmark} {
					opacity: 1;
				}
			}
		}
	}

	:focus {
		+ ${StyledFocusWrapper} {
			::after {
				content: '';
				position: absolute;
				width: 100%;
				height: 100%;
				border-width: 2px 0;
				border-color: ${props => props.theme.focusColor};
				align-self: center;
				border-style: solid;
				pointer-events: none;
			}
		}
	}

	/* we need a higher specificity here than :hover */
	&&&:disabled {
		+ ${StyledFocusWrapper} {
			color: ${props => props.theme.interaction.recipe450.disabled};
			cursor: not-allowed;
		}
	}
`;
class Checkbox extends React.Component {
    constructor() {
        super(...arguments);
        this.handleChange = (e) => {
            const { onChange = noop } = this.props;
            onChange(e, this.props);
        };
        this.handleBlur = (e) => {
            const { onBlur = noop } = this.props;
            onBlur(e, this.props);
        };
        this.handleFocus = (e) => {
            const { onFocus = noop } = this.props;
            onFocus(e, this.props);
        };
        this.handleClick = (e) => {
            const { onClick = noop } = this.props;
            e.currentTarget.focus();
            onClick(e, this.props);
        };
    }
    render() {
        const { checked, defaultChecked, disabled, label = '', name, value, required, appearance, errorText, tabIndex } = this.props;
        const errorShouldBeVisible = Boolean(appearance === CheckboxAppearance.Error && errorText);
        return (React.createElement(StyledLabel, null,
            React.createElement(StyledInput, { checked: checked, defaultChecked: defaultChecked, disabled: disabled, name: name, onBlur: this.handleBlur, onChange: this.handleChange, onClick: this.handleClick, onFocus: this.handleFocus, type: "checkbox", value: value, required: required, tabIndex: tabIndex }),
            React.createElement(StyledFocusWrapper, null,
                React.createElement(StyledCheckboxWrapper, null,
                    React.createElement(CheckboxCheckmark.CheckboxBorder, { variant: "default" }),
                    React.createElement(StyledCheckboxCheckmark, { variant: "default" })),
                React.createElement("span", null,
                    label &&
                        (typeof label === 'string' ? (React.createElement(text_1.Text, { tag: text_1.TextTag.span, color: text_1.TextColor.inherit }, label)) : (label)),
                    React.createElement(StyledErrorText, { "aria-live": "assertive", "aria-relevant": "all" }, errorShouldBeVisible && errorText)))));
    }
}
exports.Checkbox = Checkbox;
